import { DOMAINS } from '@/constants/domains';
import { env } from '@/environment';

const PROD_ENVS: string[] = [DOMAINS.STAGE, DOMAINS.PROD];

export const isProdEnv = () => PROD_ENVS.includes(env.ORIGIN);
export const getIsProdBuild = () => env.NODE_ENV === 'production';
